import axios from "axios";

const clientReport = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_CALENDARIO_ATTIVITA,
    responseType: 'blob',
});
export default clientReport;